import { formatDate } from 'helpers/date';
import { API_MYEDUZZ } from 'settings';

import { apiServiceProxy, type ApiServiceProxy } from '../api-proxy';
import type { ICDFFiles, ICDFItems, ICDFList, IFilterParams } from './types';

class CDFService {
  constructor(private apiService: ApiServiceProxy) {}

  public async getList(params: IFilterParams) {
    return this.apiService.get<ICDFList>(`${API_MYEDUZZ}/fiscaldocuments`, {
      ...params,
      received_at: params.received_at ? formatDate(params.received_at, 'yyyy-MM-dd') : null,
      received_at_final: params.received_at_final ? formatDate(params.received_at_final, 'yyyy-MM-dd') : null
    });
  }

  public async getDetailsItems(id: number) {
    return this.apiService.get<ICDFItems>(`${API_MYEDUZZ}/fiscaldocuments/${id}/items`);
  }

  public async getDetailsFiles(id: number) {
    return this.apiService.get<ICDFFiles>(`${API_MYEDUZZ}/fiscaldocuments/${id}/downloads`);
  }

  public async urlDownload(id: number) {
    return this.apiService.get(`${API_MYEDUZZ}/fiscaldocuments/${id}/export`);
  }

  public async export(params: IFilterParams) {
    return this.apiService.get(`${API_MYEDUZZ}/fiscaldocuments/export`, {
      ...params,
      received_at: params.received_at ? formatDate(params.received_at, 'yyyy-MM-dd') : null,
      received_at_final: params.received_at_final ? formatDate(params.received_at_final, 'yyyy-MM-dd') : null
    });
  }
}

export const cdfService = new CDFService(apiServiceProxy);
